import React from 'react';
import currentUserState from '@globalState/currentUserState';
import Companies from './Companies';

export default () => {
  const currentUser = currentUserState.useValue();
  return <div>{currentUser?.isAdmin ? <Companies /> : null}</div>;
};
